import React, { useState } from 'react'

const Tooltip = ({ text, children, position = 'bottom' }) => {
    const [isVisible, setIsVisible] = useState(false);

    const tooltipStyle = {
        position: 'absolute',
        fontWeight: 'normal',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'white',
        color: '#4E555F',
        padding: '5px 10px',
        border: '0.5px solid rgb(224, 224, 228)',
        borderRadius: '5px',
        zIndex: 1000,
        width: '250px',
        textAlign: 'center',
        fontSize: '12px',
        ...(position === 'bottom' ? {
            top: '100%',
            marginTop: '5px'
        } : {
            bottom: '100%',
            marginBottom: '5px'
        })
    };

    return (
        <div
            style={{ position: 'relative', display: 'inline-block' }}
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            {children}
            {isVisible && (
                <div style={tooltipStyle}>
                    {text}
                </div>
            )}
        </div>
    );
};

export default Tooltip
